<template>
  <BaseButtonDropdown close-on-click>
    <template #btn="{ toggle }">
      <BaseButton
        :aria-label="getLocaleText('sentiment_picker.toggle_sentiment')"
        bordered
        new-design
        size="sm"
        @click.stop="toggle"
      >
        <BaseIcon
          :icon="balancedOption.icon"
          new-design
          new-icon
          :style="{ color: balancedOption.color }"
        />
      </BaseButton>
    </template>

    <div class="tw:col">
      <div
        v-for="option in sentimentOptions"
        :key="option.value"
      >
        <BaseButton
          :aria-label="
            getLocaleText('sentiment_picker.select_sentiment_rating')
          "
          :icon="option.icon"
          new-design
          new-icon
          :style="{ color: option.color }"
          @click="selectRating(option)"
        />
      </div>
    </div>
  </BaseButtonDropdown>
</template>

<script setup lang="ts">
import { type DesignSystemIcons } from "design-system/types";

import { getLocaleText } from "shared/boot/i18n";
import { BaseButton, BaseButtonDropdown } from "shared/components/base";
import BaseIcon from "shared/components/base/BaseIcon";

import type { SentimentOption } from "./sentimentOptions";
import sentimentOptions from "./sentimentOptions";

const emit = defineEmits<{
  change: [number];
}>();

const balancedOption: { color: string; icon: DesignSystemIcons } = {
  icon: "balanced",
  color: "#3e475e",
};

function selectRating(sentimentOption: SentimentOption) {
  emit("change", sentimentOption.value);
}
</script>
